import Fingerprint2 from 'fingerprintjs2';
import {IS_SERVER} from "../common";

export const createImprintHash = () => {
    if (IS_SERVER) return
    return new Promise(resolve => {
      const fn = (components) => {
        const imprintHash = Fingerprint2.x64hash128(components.map(pair => pair.value).join(), 31);
        resolve(imprintHash);
      }
      if (window.requestIdleCallback) {
        requestIdleCallback(() => Fingerprint2.get(fn));
      } else {
        setTimeout(() => Fingerprint2.get(fn), 500);
      }
    })

}
